import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, CircularProgress, Stack, Button, Box, FormControl, MenuItem, Select } from '@mui/material';
// import LockIcon from '@mui/icons-material/Lock';
import FreeBlockModal from 'sections/premiumBlock/FreeBlockModal';
import { openModal } from 'store/reducers/actions';

import ICPProfile from './ICP/ICPProfile';
import { setExtendedAnalysisResults } from 'store/reducers/actions';
import { openSnackbar } from 'store/reducers/snackbar';
import BlockedInput from 'sections/askPage/BlockedInput';
import { generateICPForSegment } from 'services/icpService';
import MarketOverview from './Market/MarketOverviewResolver';
import marketMock from './Market/dataMock';
import PricingAnalysisSection from './PricingAnalysisSection';
// import VisibilityIcon from '@mui/icons-material/Visibility';
import USPSection from './USPSection';
import MarketTrends from './MarketTrends';
import CompetitorsLPReport from './CompetitorsLPReport';

import SegmentationAdapter from './SegmentationAdapter';
import { detectSegmentationStructure } from 'utils/structureUtils';
import NewSwotGroup from './NewSwotGroup';
import ReviewsAnalysisBlock from './ReviewsAnalysisBlock';
import { getCompetitorsSearchData } from 'utils/competitorsDataUtils';

const ExtendedAnalysisGroup = ({ analysisData, processSubmit }) => {
  const dispatch = useDispatch();
  const extendedAnalysisResults = useSelector((state) => state.extendedAnalysisReducer.extendedAnalysisResults);
  const historyResult = useSelector((state) => state.historyReducer.historyResult);

  const plan = useSelector((state) => state.proAccountReducer.plan);
  const trialWasActivated = useSelector((state) => state.proAccountReducer.trial_was_activated);
  const userCountry = useSelector((state) => state.proAccountReducer.country);
  const restrictedCountries = ['IN', 'VN', 'CN', 'BD', 'PK', 'ID'];
  const trialAllowed = !trialWasActivated && !restrictedCountries.includes(userCountry);
  const isProUser = plan === 'Trial' || plan === 'Pro' || plan === 'Pro+' || plan === 'Enterprise Pro Max' || plan === 'Enterprise Pro';
  const isModalOpen = useSelector((state) => state.modalReducer.isOpen);
  const [hoveredItems, setHoveredItems] = useState({});

  // Check if extended analysis is still processing
  const isExtendedAnalysisComplete = !extendedAnalysisResults?.processing_status;

  // Check if reviews analysis data is available
  // const reviewsState = useSelector((state) => state.reviewsReducer);
  // const hasReviewsAnalysis = reviewsState.v2Data || (reviewsState.analysisData && reviewsState.analysisData.review_analysis_results);

  const handleTrialClick = () => {
    // Track event in Yandex Metrika
    if (window.ym) {
      window.ym(94496474, 'reachGoal', 'REPORT_TRIAL_CLICK');
      // console.log('Report trial click tracked');
    }

    dispatch(
      openModal({
        title: 'Get access to extended pricing analysis',
        subtitle: "Upgrade to Pro to view extended pricing analysis. Don't miss out on accessing more insights!",
        trial: trialAllowed
      })
    );
  };

  // const businessAnalysis = extendedAnalysisResults.business_analysis;
  const qp = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('mock_market') : null;
  const useMockMarket = qp === '1' || process.env.REACT_APP_USE_MARKET_MOCK === 'true';
  const marketOverview = useMockMarket ? marketMock : extendedAnalysisResults.market_overview;
  const segmentation = extendedAnalysisResults.segmentation;
  const marketTrends = extendedAnalysisResults.market_trends_and_benchmarks;
  const usp = extendedAnalysisResults.usp;
  // console.log(extendedAnalysisResults)
  // console.log(usp)

  const taskId = useSelector((state) => state.currentTaskReducer.task_id);

  const structureType = detectSegmentationStructure(segmentation);

  const [currentSegment, setCurrentSegment] = useState('');
  const [isCreatingICP, setIsCreatingICP] = useState(false);

  useEffect(() => {
    if (extendedAnalysisResults?.icp && Object.keys(extendedAnalysisResults.icp).length > 0 && !currentSegment) {
      setCurrentSegment(Object.keys(extendedAnalysisResults.icp)[0]);
    }
  }, [extendedAnalysisResults, currentSegment]);

  const icpData = extendedAnalysisResults?.icp?.[currentSegment];

  // const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  // Get the URL from analysisUrlReducer instead of analysisData
  const analysisUrl = useSelector((state) => state.analysisUrlReducer.analysisUrl);

  const handleCreateICP = async (segmentName, taskId) => {
    setIsCreatingICP(true);
    try {
      const response = await generateICPForSegment(taskId, segmentName);
      const newIcpData = response.icp;
      dispatch(
        setExtendedAnalysisResults({
          ...extendedAnalysisResults,
          icp: {
            ...extendedAnalysisResults.icp,
            [segmentName]: newIcpData
          }
        })
      );
      setIsCreatingICP(false);
      setCurrentSegment(segmentName);
    } catch (error) {
      console.error('An error occurred:', error);
      dispatch(
        openSnackbar({
          open: true,
          message: 'Failed to create ICP. Please try again.',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: false
        })
      );
      setIsCreatingICP(false);
    }
  };

  const handleScrollToICP = (segmentName) => {
    const element = document.getElementById('icp-profile');
    if (element) {
      const yOffset = -80; // Adjust this value as needed
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    setCurrentSegment(segmentName);
  };

  return (
    <>
      {!isProUser && isModalOpen ? <FreeBlockModal /> : null}
      {/* <div id="business-analysis">
        <Stack mt={5} spacing={2} direction="row" alignItems="center" justifyContent="center">
          <Typography variant="h3" align="center">
            Business Overview
          </Typography>
          {!businessAnalysis && <CircularProgress size={24} />}
        </Stack>
        {businessAnalysis !== null
          ? Object.entries(businessAnalysis).map(([key, value], index) => {
              const itemKey = `business-analysis-${index}`;
              return (
                <Box
                  key={key}
                  onMouseEnter={() => setHoveredItems((prev) => ({ ...prev, [itemKey]: true }))}
                  onMouseLeave={() => setHoveredItems((prev) => ({ ...prev, [itemKey]: false }))}
                >
                  <Typography variant="h4" my={2} align="left">
                    {key}
                  </Typography>
                  {index === 0 || isProUser ? (
                    <Typography variant={matchDownSM ? 'body2' : 'body1'}>{value}</Typography>
                  ) : (
                    <Box mt={0} sx={{ position: 'relative', overflow: 'hidden' }}>
                      <Box
                        sx={{
                          filter: 'blur(5px)',
                          userSelect: 'none',
                          position: 'relative',
                          padding: 0,
                          opacity: 0.6
                        }}
                      >
                        <Typography variant={matchDownSM ? 'body2' : 'body1'} align="left">
                          {value}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                          opacity: 0.5,
                          transition: 'opacity 0.3s, transform 0.3s',
                          cursor: 'pointer',
                          '&:hover': {
                            opacity: 1,
                            transform: 'scale(1.05)'
                          }
                        }}
                        onClick={handleTrialClick}
                      >
                        <VisibilityIcon />
                        <Typography variant="caption" color="black" ml={1}>
                          View
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                    <FeedbackButtons
                      blockId={`business-analysis-${key}`}
                      blockType="business-analysis"
                      blockTitle={key}
                      blockContent={String(value)}
                      taskId={taskId}
                      serviceName={analysisData ? analysisData['Service Name'] : 'N/A'}
                      isVisible={!!hoveredItems[itemKey]}
                    />
                  </Box>
                </Box>
              );
            })
          : null}
      </div> */}

      <USPSection
        usp={usp}
        isProUser={isProUser}
        handleTrialClick={handleTrialClick}
        analysisData={analysisData}
        trialAllowed={trialAllowed}
      />

      {getCompetitorsSearchData(historyResult, extendedAnalysisResults) && (
        <Box id="competitors">
          <CompetitorsLPReport
            reportData={getCompetitorsSearchData(historyResult, extendedAnalysisResults)?.results?.final_answer}
            processSubmit={processSubmit}
            companyName={analysisData['Service Name']}
          />
        </Box>
      )}

      <div id="market-overview">
        <MarketOverview
          data={marketOverview}
          forceV2={useMockMarket}
          allowAnyRegions={useMockMarket}
          isProUser={isProUser}
          handleTrialClick={handleTrialClick}
          trialAllowed={trialAllowed}
          analysisData={analysisData}
        />
        <MarketTrends marketTrends={marketTrends} analysisData={analysisData} />
      </div>

      <NewSwotGroup analysisData={analysisData} />
      <SegmentationAdapter
        segmentation={segmentation}
        isProUser={isProUser}
        handleTrialClick={handleTrialClick}
        handleScrollToICP={handleScrollToICP}
        taskId={taskId}
        analysisData={analysisData}
        hoveredItems={hoveredItems}
        setHoveredItems={setHoveredItems}
      />

      {/* Conditionally render the ICP Profile section only for the 'old' structure */}
      {structureType === 'old' && (
        <div id="icp-profile">
          {!extendedAnalysisResults?.icp ? (
            <Stack mt={5} spacing={2} direction="row" alignItems="center" justifyContent="center">
              <Typography variant="h3" align="center">
                Ideal Customer Profile
              </Typography>
              <CircularProgress size={24} />
            </Stack>
          ) : (
            <>
              <Stack mt={5} spacing={2} direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="h3" align="left">
                  Ideal Customer Profile
                </Typography>
                <FormControl sx={{ minWidth: 200 }}>
                  <Select
                    value={currentSegment}
                    onChange={(e) => setCurrentSegment(e.target.value)}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Select segment' }}
                  >
                    {segmentation?.Segments &&
                      segmentation.Segments.map((segment, index) => (
                        <MenuItem
                          key={index}
                          value={segment.name}
                          sx={
                            !isProUser && index > 0
                              ? {
                                  filter: 'blur(3px)',
                                  pointerEvents: 'none',
                                  color: 'rgba(0, 0, 0, 0.38)'
                                }
                              : {}
                          }
                        >
                          {segment.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Stack>
              {icpData ? (
                <ICPProfile icpData={icpData} isProUser={isProUser} handleTrialClick={handleTrialClick} segmentName={currentSegment} />
              ) : isCreatingICP ? (
                <Box mt={4} display="flex" flexDirection="column" alignItems="center">
                  <BlockedInput text={`Creating ICP for ${currentSegment}, please wait...`} />
                </Box>
              ) : (
                <Box mt={4} display="flex" flexDirection="column" alignItems="center">
                  <Typography variant="body1" mb={2}>
                    To create ICP for {currentSegment}, press the button below (3 credits).
                  </Typography>
                  <Button variant="contained" color="primary" onClick={() => handleCreateICP(currentSegment, taskId)}>
                    Create ICP for this segment
                  </Button>
                </Box>
              )}
            </>
          )}
        </div>
      )}
      <div id="pricing-analysis">
        <PricingAnalysisSection
          pricingAnalysis={extendedAnalysisResults.pricing_analysis}
          handleTrialClick={handleTrialClick}
          serviceName={analysisData['Service Name']}
          isProUser={isProUser}
        />
      </div>

      {/* Show ReviewsAnalysisBlock when extended analysis is complete */}
      {isExtendedAnalysisComplete && (
        <div id="reviews-analysis">
          <ReviewsAnalysisBlock url={analysisUrl} />
        </div>
      )}
    </>
  );
};

export default ExtendedAnalysisGroup;
